export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-background-50">
              <h2 className="font-heading font-bold text-2xl md:text-3xl mb-3">有料你就来 · 爆料投稿</h2>
              <p className="text-primary-100 text-sm md:text-base leading-relaxed">
                你身边的八卦、你掌握的黑料、你拍到的现场——欢迎投稿至每日爆料平台。一经采用，丰厚稿酬等你拿。投稿即视为同意平台内容发布规则，编辑审核通过后将在24小时内上线。
              </p>
              <div className="flex flex-wrap gap-4 mt-5">
                <div className="flex items-center gap-2 text-sm text-primary-100">
                  <i className="ri-mail-line"></i>
                  <span>tougao@meiribaoliao.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-primary-100">
                  <i className="ri-wechat-line"></i>
                  <span>微信：mrbl_tougao</span>
                </div>
              </div>
            </div>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer shrink-0"
            >
              <i className="ri-send-plane-fill"></i>
              立即投稿
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}